import { type FC, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../global-config'
import { TENANT } from '../../../tenant'
import { urlResolverGetPrivacySecurity } from '../../../url-handling'

const translationValues = (
  config: PublicGlobalConfig,
): { privacyLink: (content: ReactNode[]) => ReactNode } => {
  return {
    privacyLink: (content: ReactNode[]): ReactNode => (
      <Link color="inherit" href={urlResolverGetPrivacySecurity(config)}>
        {content}
      </Link>
    ),
  }
}

export const DirectContactFormTextInfoSection: FC = () => {
  const globalConfig = useGlobalConfigContext()

  return (
    <div className="my-4">
      {TENANT.COM === globalConfig.tenant ? null : (
        <p className="mb-3 text-s text-dark-primary-strong">
          <FormattedMessage id="medicationPlan.form.markedFieldsAreRequired" />
        </p>
      )}
      <p className="mb-3 text-s text-dark-primary-strong">
        <FormattedMessage
          id="general.label.privacyPolicyAgreement"
          values={translationValues(globalConfig)}
        />
      </p>
    </div>
  )
}
